import { createElement } from 'react';
import cn from 'classnames';
import styles from './styles.scss';
import { LoaderProps, isLoading } from './index';

interface OwnProps extends LoaderProps {
  tag?: keyof React.ReactHTML;
}

export default ({ tag, loading, className, style, children }: OwnProps) =>
  createElement(
    tag || 'div',
    {
      style: isLoading(loading) ? style : {},
      className: cn(
        styles.base,
        {
          [styles.spinner]: isLoading(loading)
        },
        className
      )
    },
    !isLoading(loading) ? children : undefined
  );
